import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.04,19.88l-.23-.14C27.76,19.13,26,18.11,26,14V6a2.0059,2.0059,0,0,0-2-2H4A2.0059,2.0059,0,0,0,2,6V26a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V24h2a2.0059,2.0059,0,0,0,2-2v-.42A1.9716,1.9716,0,0,0,29.04,19.88ZM24,26H4V21.08a9.433,9.433,0,0,0,3.63,2.85A.9349.9349,0,0,0,8,24H24Zm4-4H8.21A7.5876,7.5876,0,0,1,4,15V6H24v8c0,3.22.96,5.03,2,6.11a7.4779,7.4779,0,0,0,1.8,1.36l.2.11Z"/><path d="M7,11h8a1,1,0,0,0,0-2H7a1,1,0,0,0,0,2Zm8-1h0Z"/><path d="M20,13H7a1,1,0,0,0,0,2H20a1,1,0,0,0,0-2ZM7,14H7Z"/>';
export var NoteOutlineSVG = function NoteOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
NoteOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(NoteOutlineSVG);